<template>
  <v-container fluid>
    <v-row class="mb-2" align="center">
      <v-col cols="auto" class="text-h6">Dividenden</v-col>
      <v-col cols="auto" class="text--secondary">
        Summe: <span class="font-weight-medium">{{ fmtEur(total) }}</span>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-btn small text @click="reload">
          <v-icon left small>mdi-refresh</v-icon>
          Aktualisieren
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="dividends"
        :items-per-page="-1"
        sort-by="datum"
        :sort-desc="true"
        dense
        class="elevation-1"
        no-data-text="Keine Dividenden erfasst"
    >
      <template v-slot:item.name="{ item }">
        <div class="font-weight-medium">{{ item.name || item.isin }}</div>
        <div class="text--secondary text-caption">{{ item.isin }}</div>
      </template>

      <template v-slot:item.datum="{ item }">
        {{ fmtDate(item.datum) }}
      </template>

      <template v-slot:item.betrag="{ item }">
        <span class="green--text text--darken-2">{{ fmtEur(item.betrag) }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {fmtDate, fmtEur} from "./finanzenFormat";

export default {
  name: "DividendenView",
  data: () => ({
    headers: [
      {text: "Name / ISIN", value: "name"},
      {text: "Datum", value: "datum"},
      {text: "Betrag", value: "betrag", align: "end"},
    ],
  }),
  computed: {
    dividends() {
      return this.$store.state.smarthaus.finanzen.dividends
    },
    total() {
      return this.dividends.reduce((s, d) => s + (d.betrag || 0), 0)
    },
  },
  methods: {
    fmtDate, fmtEur,
    reload() {
      this.$store.dispatch('update', {"context": '/shares/dividends'})
    },
  },
  mounted() {
    this.reload()
  },
}
</script>
